// extracted by mini-css-extract-plugin
export var productImage = "_k4-1";
export var viewLink = "_k4-2";
export var wishlistItem = "_k4-0";